export default function formatNumberWithCommas(value: number) {
  return value?.toLocaleString();
}
